export default {
  // Asignación de roles a usuarios
  assign: 'Asignar',
  assign_role: 'Asignar Rol',
  assign_role_error: 'Error al asignar el rol',
  assign_role_success: 'Rol asignado correctamente',
  assign_role_none_created:
    'No se creó ninguna asignación. Verifica que las ubicaciones pertenezcan ' +
    'a la franquicia seleccionada o que la asignación no exista ya.',
  assign_role_partial: 'Algunas asignaciones no se crearon. Revisa las ubicaciones y franquicias seleccionadas.',
  assigned_roles: 'Roles Asignados',
  assign_role_more: '{locations} y {count} más',
  assign_role_reason_exist: 'ya asignadas antes: {locations}',
  assign_role_reason_franchise: 'fuera de la unidad de negocio del rol: {locations}',
  assign_role_reason_exist_no_location: 'el rol ya estaba asignado en esa unidad de negocio u organización',
  assign_role_none_prefix: 'No se creó ninguna asignación —',
  assign_role_partial_prefix: 'Asignaciones creadas: {created}. Se omitieron —',

  // Listado y acciones masivas de usuarios
  users_options: 'Usuarios',
  add_user: 'Agregar usuario',
  enable_users: 'Activar usuarios',
  enable_users_message: 'Estás por activar todos los usuarios de esta francquicia ¿Seguro que deseas continuar?',
  disable_users: 'Desactivar usuarios',
  disable_users_message: 'Estás por desactivar todos los usuarios de esta francquicia ¿Seguro que deseas continuar?',

  // Datos personales del usuario (usado en users + profile)
  user: {
    first_name: 'Nombre',
    first_name_placeholder: 'Ej. Juan',
    last_name: 'Apellido',
    last_name_placeholder: 'Ej. Pérez',
    email: 'Correo',
    email_placeholder: "correo{'@'}ejemplo.com",
    external_id: 'ID Externo',
    external_id_placeholder: '0000000',
    internal_id: 'ID Interno'
  },

  // Formulario de usuario (tipo de cuenta)
  user_is_demo: 'Usuario Demo',
  is_real_mail: 'El Correo Es Real',
  user_is_aria: 'Usuario Aria',
  user_security_title: 'Seguridad y sesiones',
  user_security_biometric_title: 'Desactivar inicio biométrico',
  user_security_biometric_text: 'Mantiene su sesión abierta; la huella o Face ID dejará de funcionar en sus dispositivos.',
  user_security_biometric_confirm: '¿Desactivar el inicio biométrico de {user}? Seguirá con su sesión abierta, sin huella ni Face ID.',
  user_security_sessions_title: 'Cerrar todas las sesiones',
  user_security_sessions_text: 'Cierra su sesión en todos sus dispositivos, incluida la web.',
  user_security_sessions_confirm: '¿Cerrar todas las sesiones de {user}? Tendrá que volver a iniciar sesión en todos sus dispositivos.',
  user_security_biometric_done: 'Inicio biométrico desactivado',
  user_security_biometric_done_by: 'Desactivado el {date} por {name}',
  user_security_biometric_done_at: 'Desactivado el {date}',
  user_security_biometric_done_via_sessions_by: 'Desactivado al cerrar sus sesiones el {date} por {name}',
  user_security_biometric_done_via_sessions_at: 'Desactivado al cerrar sus sesiones el {date}',
  user_security_biometric_relogin: 'Se desactivó el {date}; inició sesión después y pudo volver a activarlo.',
  user_security_sessions_done: 'Sesiones cerradas',
  user_security_sessions_done_by: 'Cerradas el {date} por {name}',
  user_security_sessions_done_at: 'Cerradas el {date}',
  user_security_sessions_relogin: 'Se cerraron el {date}; inició sesión después.',
  user_security_confirm_ok: 'Confirmar',
  user_security_success: 'Listo, se aplicará en unos segundos.',
  user_security_forbidden: 'No tienes permisos para realizar esta acción sobre este usuario.',
  user_security_error: 'No se pudo completar la acción. Intenta de nuevo.',

  // Resumen ejecutivo de Aria (insights periódicos, ver Chat.vue)
  user_is_aria_insights: 'Insights proactivos de Aria',
  aria_executive_summary: 'Resumen ejecutivo',
  aria_period_weekly: 'Semanal',
  aria_period_biweekly: 'Quincenal',
  aria_period_monthly: 'Mensual',

  // Tipos de usuario (filtros del listado)
  basic_users: 'Básicos',
  standard_users: 'Estándar',
  demo_users: 'Demo',

  // Exportar reporte de usuarios

  // Aviso de expiración de cuenta demo (mixin global currentUser.js + profile/organizations)
  demo_message: 'Esta cuenta es demo y estará disponible hasta',
  demo_expiration: 'Tu demo ha expirado',
  expiration_message: 'Tu tiempo de demostración ha expirado. Para aclaraciónes contacta a tu administrador.',

  // Estado de cuenta demo de un usuario (consumido hoy solo desde Organization.vue)
  username: 'Alias',
  demo_expirated: 'La cuenta demo expiró el',
  demo_user_update: 'Usuario demo actualizado',
  demo_date_message: 'Se ha actualizado el periodo demo del usuario seleccionado',

  // Huérfanas migradas desde labels.js (sin consumidor confirmado, ver hallazgo Fase 2)
  user_is_basic: 'Usuario Básico',
  aria_users: 'Aria',
  account_number: 'Número de cuenta',
  users_number: 'Número de usuarios',
  exceed_users_limit: 'No puedes crear más usuarios de este tipo, has llegado a tu limite.',
  registration_problem: 'Error al registrar',
  demo_until: 'Demo hasta',
  export_header_franchise: 'Franquícia',
  download_report: 'Descargar Reporte de Usuarios'
}
